import { BatchDeltasColDefs } from '../../models/batch-deltas-col-defs.model';

export function formatGridValueOrNA(params: any): string {
  const value = params?.value;

  if (
    value === null ||
    value === undefined ||
    value === '' ||
    (typeof value === 'string' && value.trim().toLowerCase() === 'null') ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return 'N/A';
  }

  return typeof value === 'number' && isNaN(value) ? 'N/A' : String(value);
}


export function getAgGridFilterType(dataType: string): string {
  switch (dataType) {
    case 'number':
      return 'agNumberColumnFilter';
    case 'date':
      return 'agDateColumnFilter';
    default:
      return 'agTextColumnFilter';
  }
}

export function buildQueryParamsFromFilterModel(filterModel: any): URLSearchParams {
  const params = new URLSearchParams();
  // filter__Territory__icontains=AU
  // should be in format: Asset__Metadata__TitleInternalAlias__icontains=MUNE
  // format: [Full field name]__[filter type]=[value]

  // Create a lookup map for quick access to column definitions
  const columnDefMap = new Map();
  BatchDeltasColDefs.forEach(colDef => {
    columnDefMap.set(colDef.field, colDef);
  });

  Object.entries(filterModel).forEach(([field, filter]) => {
    const f = filter as Record<string, any>;
    if (!f["filterType"] || !f["type"]) return;

    const filterType = f["filterType"];
    const type = f["type"];

    // Get the column definition and use filterPath if available
    const colDef = columnDefMap.get(field);
    const actualFieldPath = colDef?.filterPath || field;

    if (filterType === 'date') {
      const dateFrom = f["dateFrom"];
      const dateTo = f["dateTo"];

      switch (type) {
        case 'equals':
          params.append(`${actualFieldPath}`, dateFrom);
          break;
        case 'lessThan':
          params.append(`${actualFieldPath}__lt`, dateFrom);
          break;
        case 'greaterThan':
          params.append(`${actualFieldPath}__gt`, dateFrom);
          break;
        case 'inRange':
          if (dateFrom) params.append(`${actualFieldPath}__gte`, dateFrom);
          if (dateTo) params.append(`${actualFieldPath}__lte`, dateTo);
          break;
      }
    }

    // console.log(`Processing filter for field: ${field} -> ${actualFieldPath}, type: ${type}, filterType: ${filterType}`);

    if (filterType === 'set') {
      // Handle agSetColumnFilter
      const values = f["values"];
      if (values && values.length > 0) {
        values.forEach((value: any) => {
          params.append(`${actualFieldPath}`, value);
        });
      }
    }

    if (filterType === 'text' || filterType === 'number') {
      const value = f["filter"];

      switch (type) {
        case 'equals':
          params.append(`${actualFieldPath}`, value);
          break;
        case 'contains':
          params.append(`${actualFieldPath}__icontains`, value);
          break;
        case 'lessThan':
          params.append(`${actualFieldPath}__lt`, value);
          break;
        case 'greaterThan':
          params.append(`${actualFieldPath}__gt`, value);
          break;
        case 'notEqual':
          params.append(`${actualFieldPath}__ne`, value);
          break;
      }
    }
  });

  return params;
}
